import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { ACCOUNT_OWNED_REQUIRED_MSG } from 'src/pages/reportUsage/utils/dataModificaionUtil';

export const useReportUsageFooterButtonsEffect = ({
  showReportPayment,
  myCaseResourceType,
  dispatch,
  setIsErrorExist,
  checkIfValidData,
  itemTableData,
  setFooterButtonStatuses,
  footerButtonStatuses, //?
  cancel,
  saveAndExit,
  replenish,
  isReportPaymentScreen,
  errForEmptyHrefIdField,
  errForEmptyPatientField,
    patientIdMandatory,
  reportUsagePatientDetails,
  reportUsagePatientDetailsMandatory,
  usageDetails,
  patientDetails,
  isPricingDone,
  filteredProduct,
  t,
  checkIfValidPricedItems,
  toggleHidePricesBtn,
  toggleSaveExitButton,
  isErrorFoundInProcedure,
  isErrorFoundInFirstLevel,
  currentActivity,
  countryCode,
  createRecordAndReplenDraftOrderObj,
  replenGridData,
  reportUsageFormObj,
  surgeryNumber,
  priceOverrideReason,
  pricingNotes,
  setReportUsageFormObj,
  resetProgressBarStatus,
  showCancelPopUp,
  replenishmentPageVisibilityUsage,
  procedurePageVisibility,
  procedure,
  review
}) => {
  useEffectWithErrorLogging(() => {
        // enable/disable Replen footer button based on item table data
        // if (validProducts) {
        // const validatedItemTableData = getValidatedItemTableData(
        //     filteredProduct,
        //     validProducts
        // );

        !(showReportPayment && myCaseResourceType !== 'reportPayment') &&
            dispatch(setIsErrorExist(!checkIfValidData(itemTableData)));
        // }

        let batchRequiredMissingSerial = false;
        const patientNameRequired = patientIdMandatory ||
            (reportUsagePatientDetails?.includes('name') &&
                reportUsagePatientDetailsMandatory?.includes('name'));
        const patientNameMissing = patientNameRequired &&
            (!patientDetails?.patientFirstName?.trim() ||
                !patientDetails?.patientLastName?.trim());
               
        if (Array.isArray(filteredProduct)) {
            filteredProduct.forEach(item => {
                if (item.isBatchRequired) {
const missing = item.lotSerialUnknown === true
    ? false
    : !Array.isArray(item.lotSerial) || item.lotSerial.some(ls => (ls.lotSerialUnknown === true ? false : !ls.Serial || String(ls.Serial).trim() === ''));
                    if (missing) {
                        item.lotSerialError = true;
                        batchRequiredMissingSerial = true;
                    } else {
                        item.lotSerialError = false;
                    }
                } else {
                    item.lotSerialError = false;
                }
            });
        }

        setFooterButtonStatuses((prevBtnState) => {
            // Ensure only the next primary action is visible on Record screen
            let correctedState = currentActivity === 'Record'
                ? prevBtnState.map((x) => {
                    if (x.btnType === 'primary') {
                        const correctBtn = replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review;
                        return { ...x, btnVisibility: x.btnName === correctBtn };
                    }
                    return x;
                })
                : prevBtnState;

            let replenBtnValidation = correctedState.map((x) =>
                    x.btnName !== cancel &&
                    x.btnName !== saveAndExit &&
                    (replenishmentPageVisibilityUsage ? x.btnName === replenish : procedurePageVisibility ? x.btnName === procedure : x.btnName === review) &&
                    !isReportPaymentScreen &&
                    x.btnVisibility
                    ? {
                        ...x,
                        isBtnDisable:
                            batchRequiredMissingSerial ||
                            errForEmptyPatientField?.length > 0 ||
                            patientNameMissing ||
                            (reportUsagePatientDetails?.includes('sex') &&
                                reportUsagePatientDetailsMandatory?.includes(
                                    'sex'
                                ) &&
                                (usageDetails?.unidId ||
                                    patientDetails?.patientSex.length < 1)) ||
                            (reportUsagePatientDetails?.includes('dob') &&
                                reportUsagePatientDetailsMandatory?.includes(
                                    'dob'
                                ) &&
                                (usageDetails?.unidId ||
                                    patientDetails?.patientDOB)) ||
                            !(isPricingDone
                                ? filteredProduct?.length > 0 &&
                                filteredProduct.every(
                                    (item) =>
                                        (!item.isInvalidItemMsg ||
                                            (item.isInvalidItemMsg ===
                                                ACCOUNT_OWNED_REQUIRED_MSG &&
                                                item.accountOwned === true)) &&
                                        item.lotSerial?.every(
                                            (x) =>
                                                x.isInvalidLotSerialMsg !==
                                                t(
                                                    'productValidationMessages.ProductissueCare'
                                                )
                                        ) &&
                                        (item.isBundleItem
                                            ? item.children?.length > 0 &&
                                            item.children.every(
                                                (child) =>
                                                    !child.isInvalidItemMsg
                                            )
                                            : true)
                                )
                                : checkIfValidPricedItems(
                                    filteredProduct,
                                    false,
                                    true
                                )),
                                // || toggleHidePricesBtn !== 'hideBtn',
                    }
                    : x
            );

            return replenBtnValidation.map((x) =>
                x.btnName !== cancel &&
                    x.btnName === saveAndExit &&
                    x.btnVisibility
                    ? {
                        ...x,
                        isBtnDisable: toggleSaveExitButton(
                            filteredProduct,
                            true,
                            isErrorFoundInProcedure,
                            isErrorFoundInFirstLevel,
                            currentActivity,
                            countryCode
                        ),
                    }
                    : x
            );
        });

        const updatedObj = createRecordAndReplenDraftOrderObj(
            usageDetails,
            patientDetails,
            filteredProduct,
            replenGridData,
            myCaseResourceType,
            reportUsageFormObj,
            reportUsagePatientDetails,
            countryCode,
            surgeryNumber
        );
        setReportUsageFormObj((prevStateObj) => {
            const reportUsageObj = {
                ...prevStateObj,
                ...updatedObj,
            };
            if (priceOverrideReason && !reportUsageObj.overridenReason) {
                reportUsageObj.overridenReason = priceOverrideReason;
            } else if (!priceOverrideReason) {
                delete reportUsageObj.overridenReason;
            }
            if (pricingNotes && !reportUsageObj.pricingNotes) {
                reportUsageObj.pricingNotes = pricingNotes;
            } else if (!pricingNotes) {
                delete reportUsageObj.pricingNotes;
            }
            return reportUsageObj;
        });
        if (
            errForEmptyHrefIdField?.length > 0 ||
            errForEmptyPatientField?.length > 0 ||
            (reportUsagePatientDetails?.includes('sex') &&
                reportUsagePatientDetailsMandatory?.includes('sex') &&
                (usageDetails?.unidId ||
                    patientDetails?.patientSex.length < 1)) ||
            (reportUsagePatientDetails?.includes('dob') &&
                reportUsagePatientDetailsMandatory?.includes('dob') &&
                (usageDetails?.unidId || patientDetails?.patientDOB))
        ) {
            dispatch(resetProgressBarStatus());
        }
    }, [
        filteredProduct,
        patientDetails,
        errForEmptyHrefIdField,
        errForEmptyPatientField,
        toggleHidePricesBtn,
        currentActivity,
        itemTableData,
        showCancelPopUp,
        isErrorFoundInProcedure,
        isErrorFoundInFirstLevel,
        surgeryNumber,
    ]);
};
